import { HandlesService } from '../../../core/services/handles.service';
import { UserService } from '../../../core/services';
import * as gtUtil from "../../../core/utility";

const handlesService = new HandlesService();
const userService = new UserService();

export const youtubeConnectFn = async (
  userData: any,
  updateUser: any,
  setLoader: any
) => {
  try {
    setLoader(true);

    const response = await handlesService.googleConnected();

    if (response.status === gtUtil.Constants.SUCCESS) {
      const popup = window.open(
        response.data.url,
        "_blank",
        "width=500,height=600"
      );

      if (!popup) {
        alert("Popup blocked. Please allow popups.");
        setLoader(false);
        return;
      }

      const channel = new BroadcastChannel("oauth-channel");

      channel.onmessage = async (event) => {
        if (event.data?.type === "social-auth-success") {
          const authCode = event.data.code;
          channel.close();

          try {
            const res = await handlesService.postGoogleConnected({
              code: authCode,
              influencer_id: userData.influencer_id,
            });

            if (res.status === gtUtil.Constants.SUCCESS) {
              const latest = await userService.getUpdatedUserReducer(userData);
              // No refresh for a Talent Partner / Agency (undefined): keep the
              // picked creator's UserData rather than clearing it.
              if (![undefined, null, ''].includes(latest)) updateUser(latest); // ✅ redux update
            }
          } catch (err) {
            console.error("YouTube connect error", err);
          } finally {
            setLoader(false);
          }
        }
      };
    } else {
      setLoader(false);
    }
  } catch (err) {
    console.error(err);
    setLoader(false);
  }
};